type TextareaProps = {
  id: string
  label: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
}

const Textarea = ({
  id,
  label,
  value,
  onChange,
  placeholder,
}: TextareaProps) => {
  const handleChange = (e) => {
    onChange(e.target.value)
  }
  return (
    <div className="flex flex-col gap-1">
      <label className="font-semibold" htmlFor={id}>
        {label}
      </label>
      <textarea
        placeholder={placeholder}
        className={
          'p-4 border-[1.5px] border-gray-300 rounded-lg min-h-32 max-h-64'
        }
        id={id}
        value={value}
        onChange={(e) => {
          handleChange(e)
        }}
      />
    </div>
  )
}

export default Textarea
